// @flow weak

export const appConfig = {
  // dev mode to mock async data for instance
  DEV_MODE: true,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,


  APP_NAME: 'Partner',

  // connection status text references
  CONNECTION_STATUS: {
    online: 'online',
    disconnected: 'disconnected'
  },
  // eaningGraph config
  earningGraph: {
    data: {
      API: 'eagleeye/getRevenueData'
    }
  },
  teamMates:{
    data: {
      API: 'api/teamMates'
    }
  },
  statsWidget:{
    data: {
      API: 'eagleeye/getTableData'
    }
  },
  statsTable:{
    data: {
      API: 'eagleeye/getTableData',
      tables: {
        "revenue_per_month": "7501",
        "customers_per_month": "7502",
        "active_customers_per_month":"7532",
        "active_customers_per_month_graph":"7533",
        "active_custombers_by_venue_by_program":"7535",
        "active_custombers_by_venue_by_program_bfc":"9002",
        "batch_health" : "7520",
        "venue_utilization" : "7521",
        "all_customers_list" : "7530",
        "customers_summary" : "7534",
        "sessions_list" : "7540",
        "sessions_list_football_improve" : "7543",
        "sessions_list_football_play" : "7544",
        "sessions_list_badminton_improve" : "7545",
        "sessions_list_rental" : "7547",
        "sessions_list_football_tournament" : "7548",
        "sessions_list_cricket" : "75441",
        "sessions_list_football_bbfs" : "75442",
        "sessions_list_badminton_academy" : "75443",
        "sessions_list_football_tournament_standing" : "75444",
        "sessions_buddy_allocation" : "75445",
        "fixture_buddy_allocation" : "75446",
        "all_leads_list" : "7550",
        "leads_count" : "7556",
        "daily_demo_conversion" : "7552",
        "sales_performance":"7554",
        "leads_to_be_worked_on_today":"7555",
        "revenue_breakup_by_program": "7504",
        "revenue_breakup_by_package": "7505",
        "revenue_breakup_by_package_duration": "7506",
        "revenue_by_venue":"7509",
        "package_list":"7514",
        "revenue_per_month_by_program":"7562",
        "revenue_per_month_by_program_graph":"7569",
        "customers_by_venue":"7510",
        "cash_collection_report": "7507",
        "cash_collection_per_day": "7511",
        "collection_trends": "7513",
        "cohort": "7564",
        "sessions_lists": "75447",

        "hot_leads_last_30_days": "75448",
        "pending_renewals_last_30_days": "75449",
        "capacity_to_actuals": "75450",
        "daily_revenue_by_game_type": "75463",
        "partner_revenue_per_month_by_program": "75473",
        "partner_collection_per_day": "754792",
        "partner_demo_scheduled": "754492",

        "batch_health": "76004",
        
        "renewal_leads": "76002",
    
        "active_customers": "76005",

        "lead_summary": "76001",
      
        "hot_leads": "76003",  
       
        "all_leads": "76006",

        "football_play_all_leads_list": "754785",
        "tournament_all_leads_list": "754790",

        "partner_rental": "75475",
        "partner_bulk_booking":"22222",
        "partner_rental_grid": "754751",
        "football_play_collection_per_customer": "754788",

        "partner_rental_per_month": "754780",
        "football_play_collection_per_month": "754786",

        "football_play_collection_per_day": "754787",
        "partner_rental_per_day": "754781",

        "tournament_teams": "75474",
        "tournament_summary": "75472",

        "support_tickets":"7580",
        "football_votein": "6969",
        "badminton_votein": "6968",
        "paypergame_summary": "6543",
        "response": "760031",
        "contact_later": "760032",
        "demo": "760033",
        "verbal_confirmation": "760034",
        "customer_feedback_queries": "76007",
        "customers_two_weeks_attendance": "76008",

        "customer_feedback_queries_badminton": "760007",

        "event_summary":"70008",
        "temp_collection": "215",

        "summercamp_lead_summary":"75502",
        "summercamp_leads_to_be_worked_on":"75503",
        "summercamp_all_leads_list":"75504",
        "summercamp_signups_to_revenue":"75500",
        "summercamp_renewal_leads":"75505",
        "summercamp_active_customers":"75501",
        "summercamp_lead_summary_badminton":"8008",

        "renewal_list_upcoming": "760010",
        "renewal_list_overdue": "760011",
        "renewal_list_dormant": "760012",
        "renewal_list_paused": "760013",

        "all_customers": "760014",
        "daily_rental": "754753",

        "bfc_cust_list": "90001",

        "active_customers_today": "7536",
        "court_usage_daily_data": "1452",
        
        "active_customers_regular": "90005",
        "active_customers_irregular": "90002",
        "active_customers_inactive": "90003",
        "active_customers_paused": "90004",
        "support_tickets_app": "900015",
        "batch_capacity_partner": "90017",

        "all_cust_tourny": "8900",
        "collection_this_month": "754495",
        "revenue_target_this_month": "754496",
        "Sales_Predictor":"255",
        "partner_rental_collection":"31",


      }
    }
  },
  login:{
    data: {
      API: 'auth/verify_mobile'
    }
  },
  scoreCard:{
    data: {
      API: 'eagleeye/getScoreCard',
      tables: {
        "dashboard_score_card": "7503",
        "rental_score_card": "754752",
        "revenue_score_card": "7508",
        "customers_score_card": "7531",
        "sales_score_card": "7570",
        "summercamp_score_card": "8009",
        "summercamp_score_card_badminton": "8010",
        "dashboard_score_card_bfc" : "9001",
        "score_card_football_improve": "9003",
        "score_card_football_academy": "9004",
        "score_card_badminton_improve": "9005",
        "score_card_badminton_academy": "9006",
        "score_card_badminton_play": "90011",
        "score_card_football_play": "90012",
        "score_card_rental": "90013",
        "score_card_tournament": "90014",

      }
    }
  },
  statsGraph:{
    data: {
      API: 'eagleeye/getStatsGraph',
      tables: {
        "revenue_per_month": "7500",
        "cash_collection_per_month": "7512",
        "active_customers_per_month_graph":"7533",
        "revenue_per_month_by_program":"7562",
        "revenue_per_month_by_program_graph":"7569",
        "collection_trends": "7513",
        "graph_partner_rental_per_day": "3201",
        "graph_partner_rental_per_month": "3202",
        "daily_rental_graph": "754753",
        "court_usage_daily": "1452",

      }
    }
  },
  statsCard:{
    data: {
      API: 'eagleeye/getStatsCard'
    }
  },
  locationMenu:{
    data: {
      API: 'eagleeye/getCenters/'
    }
  },
  // userInfos config
  userInfos: {
    data: {
      API: 'api/userInfos'
    }
  },

  HELLO_WORD: 'Hello'

};



// WEBPACK FOOTER //
// ./src/app/config/appConfig.js